import { CeresBopConfig } from './interfaces/ceres-bop-config.interface';

const BOPCONFIG: CeresBopConfig = {
    'bop.planned-duration': true,
    'bop.content': true,
    'bop.offer-title': true,
    'bop.offer-date': true,
    'bop.charging-volume-own': true,
    'bop.charging-volume-others': true,
    'bop.material-costs': true,
    'bop.total-volume': true,
    'bop.total-probability': true,
    'bop.expected-value': true,
    'bop.planned-project-start': true,
    'bop.planned-project-end': true,
    'bop.bop-status': true,
    'bop.probability-class': true,
    'bop.tags': false
};

export default BOPCONFIG;
